import styled from "styled-components";

import { Caption } from "@components/Typography";

export const CaptionText = styled(Caption)`
  text-transform: uppercase;
  font-size: 0.88em;
`;
